import '../css/wait_page.css';

const WaitPage = () => {

    return (
        <section className="wrapper">
            <div className="container">
                <div id="scene" className="scene" data-hover-only="false">

                    <div className="circle" data-depth="1.2"></div>

                    <div className="one" data-depth="0.9">
                        <div class="content">
                            <span class="piece"></span>
                            <span class="piece"></span>
                            <span class="piece"></span>
                        </div>
                    </div>

                    <div className="two" data-depth="0.60">
                        <div className="content">
                            <span className="piece"></span>
                            <span className="piece"></span>
                            <span className="piece"></span>
                        </div>
                    </div>

                    <div className="three" data-depth="0.40">
                        <div className="content">
                            <span className="piece"></span>
                            <span className="piece"></span>
                            <span className="piece"></span>
                        </div>
                    </div>

                    <p className="p404" data-depth="0.50">준비중</p>
                    <p className="p404" data-depth="0.10">준비중</p>

                </div>

                <div className="text">
                    <article>
                        <p>현재 보나스포츠는<br />2024년 1월중 오픈 예정입니다.</p>
                    </article>
                </div>

            </div>
        </section>
    );

}

export default WaitPage;
